(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-product-details"] && !Shopify.designMode) return;
  try {
    
  //FAQs Accordion
var acc = document.getElementsByClassName("faqs-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-faq-seo-copy"] && !Shopify.designMode) return;
  try {
    
  //FAQs Accordion
var acc = document.getElementsByClassName("faqs-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  class DiscountInput extends HTMLElement {
    constructor() {
      super();
      this.applyButton = this.querySelector("#apply-discount-button");
      this.discountCodeInput = this.querySelector("#discount-code-input");
      this.discountCodeError = this.querySelector("#discount-code-error");
    }

    connectedCallback() {
      this.applyButton?.addEventListener("click", this.handleApplyDiscount.bind(this));      
      document.addEventListener("click", this.handleClearDiscount.bind(this));
    }

    async handleApplyDiscount(event) {
      event.preventDefault();
      if (this.discountCodeInput?.value) {
        const discountCode = this.discountCodeInput.value;

        try {
          // Apply the discount code
          await this.applyDiscount(discountCode);
        } catch (error) {
          console.error("Error applying discount:", error);
        }
      }
    }

    handleClearDiscount(event) {
      if (!event.target.closest('.clear-discount-button')) {
        return;
      }
      
      event.preventDefault();
      this.clearDiscountAsync();
    }

    async clearDiscountAsync() {
      try {
        await this.clearDiscount();
      } catch (error) {
        console.error("Error clearing discount:", error);
      }
    }

    async clearDiscount() {
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: '' })
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Clear any previous error
        if (this.discountCodeError) this.discountCodeError.innerHTML = '';
        
        // Refresh cart sections
        await this.refreshCartSections();
      } catch (error) {
        console.error('Error clearing discount:', error);
      }
    }

    async applyDiscount(code) {
      if (this.applyButton) {
        this.applyButton.textContent = 'APPLYING';
        this.applyButton.disabled = true;
      }

      try {
        const res = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: code.trim() }) // multiple? 'CODE1,CODE2'
        });

        if (!res.ok) throw new Error(`Update failed: ${res.status}`);

        const cartData = await res.json();
        
        // Check if the discount was actually applied
        const appliedDiscounts = cartData.discount_codes || [];
        const isDiscountApplied = appliedDiscounts.some(discount => 
          discount.code.toLowerCase() === code.trim().toLowerCase() && discount.applicable === true
        );

        if (isDiscountApplied) {
          // Success - clear error and refresh
          if (this.discountCodeError) this.discountCodeError.innerHTML = '';
          await this.refreshCartSections();
        } else {
          // Discount not applied - show error
          this.displayError('Please enter a valid coupon code.');
        }
      } catch (error) {
        console.error('Error applying discount:', error);
        this.displayError('Please enter a valid coupon code.');
      } finally {
        if (this.applyButton) {
          this.applyButton.textContent = 'APPLY';
          this.applyButton.disabled = false;
        }
      }
    }

    displayError(message) {
      if (this.discountCodeError) {
        this.discountCodeError.innerHTML = message;
        this.discountCodeError.style.display = 'block';
        this.discountCodeError.style.color = '#e74c3c';
      }
    }

    async refreshCartSections() {         
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
    }
  }

  customElements.define("discount-input", DiscountInput);

  } catch(e) { console.error(e); }
})();
})();
